export class QuestionAnswerModel {
    id: string;
    title: string;
    score: number;
    comment: string;
}
